import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import escapeKey from '../../escape-key';

const TOGGLE_CLASS = 'header-toggle_opened';
const MENU_CLASS = 'header-popup-menu_opened';
const HEADER_CLASS = 'header_opened';
const CONTAINER_CLASS = 'header-popup-container_opened';

const header = document.querySelector('.header');
const menuEl = document.querySelector('[data-header-popup-menu]');
const toggleEl = document.querySelector('[data-header-toggle]');
const container = document.querySelector('.header-popup-container');

let opened = false;

function toggleMenu(newOpened) {
  if (newOpened === opened) {
    return;
  }
  opened = newOpened;
  if (opened) {
    disableBodyScroll(menuEl);
    setTimeout(() => container.classList.add(CONTAINER_CLASS), 700);
  } else {
    enableBodyScroll(menuEl);
    menuEl.scrollTop = 0;
    setTimeout(() => container.classList.remove(CONTAINER_CLASS), 400);
  }
  if (toggleEl) {
    toggleEl.classList.toggle(TOGGLE_CLASS);
  }
  if (menuEl) {
    menuEl.classList.toggle(MENU_CLASS);
  }
  if (header) {
    header.classList.toggle(HEADER_CLASS);
  }
}

// function togg
if (toggleEl) {
  toggleEl.addEventListener('click', () => {
    toggleMenu(!opened, toggleEl);
  });
}

if (window.isMobile.any) {
  container.classList.add('header-popup-container_mobile');
}

escapeKey(() => {
  toggleMenu(false);
});

export default toggleMenu;
